import { render, staticRenderFns } from "./colors-tab.vue?vue&type=template&id=056155f1&scoped=true&"
import script from "./colors-tab.vue?vue&type=script&lang=js&"
export * from "./colors-tab.vue?vue&type=script&lang=js&"
import style0 from "./colors-tab.vue?vue&type=style&index=0&id=056155f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056155f1",
  null
  
)

export default component.exports